import(/* webpackMode: "eager" */ "/home/runner/work/yegnaweb/yegnaweb/src/app/news/page.tsx")